const fish_image = "http://37.152.182.217:4022/payments/";

export { fish_image };
